function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-3{fill:#19a2c7;}.cls-2{fill:#232f3e;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "VPC-subnet-private_dark-bg");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Working"
}, React.createElement("rect", {
  className: "cls-1",
  width: 35,
  height: 35
}), React.createElement("path", {
  className: "cls-2",
  d: "M17.51,17.83a2.38,2.38,0,0,0-.5,4.71v3.29h1V22.54a2.38,2.38,0,0,0-.5-4.71Zm0,3.76a1.38,1.38,0,1,1,1.38-1.38A1.38,1.38,0,0,1,17.51,21.59Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M22.72,14.3V11.63a5.22,5.22,0,1,0-10.44,0V14.3H9.14V28.59H25.86V14.3Zm-9.44-2.67a4.22,4.22,0,1,1,8.44,0V14.3H13.28Zm11.58,16H10.14V15.3H24.86Z"
}));

var SvgAwsVpcSubnet = function SvgAwsVpcSubnet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "svgCloudServices",
    viewBox: "0 0 35 35",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwsVpcSubnet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AWS-VPC_Subnet.d6031692.svg";
export { ForwardRef as ReactComponent };